import { environment } from "../../environment";
import axios from "axios";

const CONTENT_URL = environment.contentUrl;
const API_PREFIX = "enhancedContent/";
const DEFAULT_HEADER = { "Content-Type": "application/json" };

export const EContentService = () => {
  ////// General Operations //////////////////////////////////

  const getAdminUsers = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getAdminUsers",
        {}
      );
    } catch (err) {
      throw err;
    }
  };

  ////// END General Operations //////////////////////////////////

  ////// Volume Query Operations //////////////////////////////////

  const getVolumeList = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getVolumeList",
        {}
      );
    } catch (err) {
      throw err;
    }
  };

  const getActiveVolumeList = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getActiveVolumeList",
        {}
      );
    } catch (err) {
      throw err;
    }
  };
  ////// END Volume Query Operations /////////////////////////////

  ////// Volume CRUD Operations //////////////////////////////////
  const createVolume = async (formData: any) => {
    try {
      return await axios.post(
        environment.contentUrl + "enhancedContent/createVolume",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const updateVolume = async (formData: any) => {
    try {
      return await axios.put(
        environment.contentUrl + "enhancedContent/updateVolume",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const deleteVolume = async (formData: string) => {
    try {
      return await axios.delete(
        environment.contentUrl + "enhancedContent/deleteVolume",
        {
          data: {
            id: formData,
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  ////// End Volume CRUD Operations //////////////////////////////

  ////// Volume Query Operations //////////////////////////////////

  const getTemplateList = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getTemplateList",
        {}
      );
    } catch (err) {
      throw err;
    }
  };

  const getActiveTemplateList = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getActiveTemplateList",
        {}
      );
    } catch (err) {
      throw err;
    }
  };

  /**
   * Create a new template
   * @param formData - The form data to create the template
   * @returns The created template
   */
  const createTemplate = async (formData: any) => {
    const url = `${CONTENT_URL}${API_PREFIX}createTemplate`;
    try {
      const data = new FormData();
      data.append("data", JSON.stringify(formData));
      if (formData.thumbnail) {
        data.append("thumbnail", formData.thumbnail);
      }
      return await axios.post(url, data, {
        headers: {
          ...DEFAULT_HEADER,
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (err) {
      throw new Error(`Error creating template: ${err}`);
    }
  };

  const createTab = async (template: any, newTab: any) => {
    try {
      const formData = {
        template: template,
        newTab: newTab,
      };
      return await axios.post(
        environment.contentUrl + "enhancedContent/createTab",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const deleteTab = async (id: any, tabTitle: any) => {
    try {
      const formData = {
        templateId: id,
        tabTitle: tabTitle,
      };
      return await axios.put(
        environment.contentUrl + "enhancedContent/deleteTab",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const updateTemplate = async (data: any) => {
    try {
      const url = `${CONTENT_URL}${API_PREFIX}updateTemplate`;
      const formData: FormData = new FormData();
      formData.append("data", JSON.stringify(data));
      formData.append("thumbnail", data.thumbnail);
      return await axios.put(url, formData, {
        headers: DEFAULT_HEADER,
      });
    } catch (err) {
      throw new Error(`Error updating template: ${err}`);
    }
  };

  const removeTemplateFromFolder = async (
    templateId: string,
    folderItemId: string
  ) => {
    try {
      const formData = {
        templateId: templateId,
        folderItemId: folderItemId,
      };
      return await axios.put(
        environment.contentUrl + "enhancedContent/removeTemplateFromFolder",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const deleteTemplate = async (templateId: string) => {
    console.log("deleteTemplate", templateId);

    try {
      return await axios.delete(
        `${environment.contentUrl}${API_PREFIX}deleteTemplate`,
        {
          data: {
            id: templateId,
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  ////// End Template CRUD Operations //////////////////////////////

  ////// Folder Query Operations //////////////////////////////////

  const getFolderList = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getFolderList",
        {}
      );
    } catch (err) {
      throw err;
    }
  };
  const getFilteredFolderList = async (key: string, value: string) => {
    try {
      return await axios.get(
        environment.contentUrl +
          `enhancedContent/getFilteredFolderList/${key}/${value}`,
        {}
      );
    } catch (err) {
      throw err;
    }
  };

  const getSHIHRFolderList = async () => {
    try {
      return await axios.get(
        environment.contentUrl + "enhancedContent/getSHIHRFolderList",
        {}
      );
    } catch (err) {
      throw err;
    }
  };
  ////// END Folder Query Operations /////////////////////////////

  ////// Folder CRUD Operations //////////////////////////////////

  const createFolder = async (formData: any) => {
    try {
      return await axios.post(
        environment.contentUrl + "enhancedContent/createFolder",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const updateFolder = async (formData: any) => {
    try {
      return await axios.put(
        environment.contentUrl + "enhancedContent/updateFolder",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  const deleteFolder = async (formData: string) => {
    try {
      const url = `${CONTENT_URL}enhancedContent/deleteFolder`;
      return await axios.delete(url, {
          data: {
            id: formData,
          },
        }
      );
    } catch (err) {
      throw err;
    }
  };

  ////// End Folder CRUD Operations //////////////////////////////

  ////// Content Items Query Operations //////////////////////////////////

  const getDivisionContentItems = async () => {
    try {
      const url = `${CONTENT_URL}enhancedContent/getDivisionContentItems`;
      const res = await axios.get(url);
      if (res && res.data) {
        return res.data;
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  const getSHIHRContentItems = async () => {
    try {
      const url = `${CONTENT_URL}enhancedContent/getSHIHRContentItems`;
      const res = await axios.get(url);
      if (res && res.data) {
        return res.data;
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  ////// End Content Items Query Operations /////////////////////////////

  return {
    getAdminUsers,
    getVolumeList,
    getActiveVolumeList,
    createVolume,
    updateVolume,
    deleteVolume,
    getTemplateList,
    getActiveTemplateList,
    createTemplate,
    createTab,
    deleteTab,
    updateTemplate,
    removeTemplateFromFolder,
    deleteTemplate,
    getFolderList,
    getFilteredFolderList,
    getSHIHRFolderList,
    createFolder,
    updateFolder,
    deleteFolder,
    getDivisionContentItems,
    getSHIHRContentItems
  };
};